module.exports = __webpack_public_path__ + "img/v1.45bfb00e.jpg";